import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { PrePrestadorService } from '@/core/api/sicom-api/servicos/pessoa-juridica/pre-prestador/pre-prestador.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { PrePrestadorRequest, PrePrestadorResponse } from '@/core/api/sicom-api/servicos/pessoa-juridica/pre-prestador/pre-prestador.model';

@Injectable({ providedIn: 'root' })
export class PrePrestadorServicosService {
    constructor(
        private api: PrePrestadorService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: PrePrestadorRequest, context?: HttpContext): Observable<PrePrestadorResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    atualizarCadastro(dto: PrePrestadorResponse, context?: HttpContext): Observable<void> {
        if (!dto?.numeroProtocolo || !dto?.anoProtocolo || !dto?.ufCrmDt) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrmDt são obrigatórios.'));
        }

        return this.api.atualizarCadastro(dto, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
